<template>
    <div>
    <p>To double check, please fill out the form below, then click <span class="font-weight-bold">Submit</span> button.</p>

    <v-row>
        <v-col cols="12" lg="6">
            <ValidationProvider v-slot="{ errors }" name="Street Name">
              <v-text-field
                label="Street Name"
                v-model="streetName"
                outlined
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" lg="6">
            <ValidationProvider v-slot="{ errors }" name="Street Type">
              <v-text-field
                label="Street Type"
                v-model="streetType"
                outlined
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" lg="6">
            <ValidationProvider v-slot="{ errors }" name="Suburb">
              <v-text-field
                label="Suburb"
                v-model="suburb"
                outlined
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" lg="6">
            <ValidationProvider v-slot="{ errors }" name="State">
              <v-text-field
                label="State"
                v-model="stateOrProvince"
                outlined
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" lg="6">
            <ValidationProvider v-slot="{ errors }" name="Postcode">
              <v-text-field
                label="Postcode"
                v-model="postcode"
                outlined
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col v-if="hasNoMatch" class="red--text font-weight-bold">
            <p>Sorry, no matching addresses found.</p>
        </v-col>
        <v-col cols="12">
            <v-btn
            class="primary"
            @click="checkAddress"
            >Submit</v-btn>
        </v-col>
    </v-row>
</div>
</template>

<script>
    export default {
        name: "AddressCheck",
        data: () => ({
            streetName: "",
            streetType: "",
            suburb: "",
            stateOrProvince: "",
            postcode: "",
            hasNoMatch: false
        }),
        methods:{
            checkAddress(){
                let vm = this;
                var payload = {
                    addressCheckMethodType: "PHYSICAL_ADDRESS",
                    addressCheckServiceType: "NBN",
                    addressValue: {
                        streetName: vm.streetName,
                        streetType: vm.streetType,
                        suburb: vm.suburb,
                        stateOrProvince: vm.stateOrProvince,
                        postcode: vm.postcode
                    }
                };
                vm.nbnAddressQuery(payload).then(data => {
                    if(data.data.length > 0){
                        data.data.forEach(element => {
                            element.locationId = element.id
                        });
                        vm.$emit("showAddresses", data);
                    }
                    else vm.hasNoMatch = true;
                });
            }
        }
    }
</script>
